import {styled} from "@mui/material/styles"

export const BannerWrapper = styled("div")`
    display: flex;
    align-items: center;
    overflow: hidden;
`
